import React from 'react'
import { AgentRegistrationStatus } from '@/components/composed/financing/AgentRegistrationStatus'
import { messages } from './messages'
import type { IPublicationFinancingWidgetCollapsingAgentRegistrationSuccessProps } from './types'

export const PublicationFinancingWidgetCollapsingAgentRegistrationSuccess: React.FC<
  IPublicationFinancingWidgetCollapsingAgentRegistrationSuccessProps
> = props => {
  const { onClose } = props

  return (
    <AgentRegistrationStatus
      icon="success"
      title={messages.title}
      subtitle={messages.subtitle}
      actionText={messages.actions.close}
      onAction={onClose}
    />
  )
}
